import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-knowledge-base",
  "use": "icon-knowledge-base-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" id=\"icon-knowledge-base\"><path d=\"M12 0c3.3 0 6 2.7 6 6s-2.7 6-6 6a5.95 5.95 0 0 1-3.057-.843l-6.389 6.389c-.604.604-1.504.604-2.104.004s-.6-1.5 0-2.1l6.607-6.607-.214.214A5.95 5.95 0 0 1 6 6c0-3.3 2.7-6 6-6m0 1.5C9.45 1.5 7.5 3.45 7.5 6s1.95 4.5 4.5 4.5 4.5-1.95 4.5-4.5-1.95-4.5-4.5-4.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol